/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-30 16:52:36
 */
import { Button, Col, Form, Input, Modal, notification, Row, Tabs } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { TabBar, TabPane } from '../../../../compnents/widgets/TabBar'
import { TraceCodeFlows } from '../TraceCodeFlow/TraceCodeFlow'
import styles from './selfRateInquirys.module.css'
import { TraceCodeScanRates } from '../TraceCodeScanRate/TraceCodeScanRate'

export const SelfRateInquirysTabs = (props:{
  selectedTab?: any
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [selectKey, setSelectKey] = useState('6')

  return (
    <Col className={styles.container}>
      <Tabs
        defaultActiveKey={'6'}
        activeKey={selectKey}
        destroyInactiveTabPane
        onChange={(v:any) => {
          setSelectKey(v)
        }}
      >
        {/* 保留原先的key */}
        <TabPane key='6' tab='追溯码流水'>
           <TraceCodeFlows selectedTab={selectKey} />
        </TabPane>
        <TabPane key='1' tab='追溯码扫码率'>
          <TraceCodeScanRates selectedTab={selectKey} />
        </TabPane>
      </Tabs>
    </Col>
  )
}
